import * as React from 'react';
import { SVGProps } from 'react';

const IconCrownSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 18h16v3H4zm16-2H4L2 7l6 3 4-7 4 7 6-3-2 9z" />
  </svg>
);
export default IconCrownSizeM;
